<template>
  <div>
    <div class="flex justify-center center col-12">
        <span class="bold block h4n">{{ billet.product_name }}</span>
      </div>
      <div
        v-if="
          billet.showSession &&
          ['reloadable', 'recurring', 'single-session'].includes(billet.type)
        "
        class="h7n flex flex-wrap justify-center pt2"
      >
        <span
          v-if="!billet.inscription && !billet.offer_type === 'STAGE'"
          class="col-12 h7n"
          >Prochain créneau réservé:</span
        >
        <div
          v-if="billet.offer_type === 'STAGE'"
          class="flex flex-wrap justify-center"
        >
          <span class="col-12"
            ><i class="icon icon-date-check-icon mr1"></i
            >{{ billet.session_start_date }} -
            {{ billet.session_end_date }}</span
          >
          <span
            ><i class="col-12 icon icon-clock mr1"></i>{{ billet.startTime }}-{{
              billet.endTime
            }}</span
          >
        </div>
        <div v-else-if="billet.inscription" class="flex">
          <span class="mr1"
            ><i class="icon icon-date-check-icon mr1"></i>Tout les
            {{ billet.session_start_weekday }}</span
          >
          <span
            ><i class="icon icon-clock mr1"></i>{{ billet.startTime }}-{{
              billet.endTime
            }}</span
          >
        </div>
        <div v-else class="flex">
          <span class="mr1"
            ><i class="icon icon-date-check-icon mr1"></i
            >{{ billet.session_start_date }}</span
          >
          <span
            ><i class="icon icon-clock mr1"></i>{{ billet.startTime }}-{{
              billet.endTime
            }}</span
          >
        </div>
      </div>
  </div>
</template>

<script setup>

// Props
const props = defineProps({
  billet: {
    type: Object,
  }
})
</script>

<style scoped>
</style>